module.exports = __webpack_public_path__ + "static/WSC_Group_2018_Individual_Income_Tax_Return_Check_List-cf467068ae75c4e0f5496d9a17658b72.pdf";